var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loader"},[_c('v-progress-circular',{attrs:{"size":126,"width":2,"color":"white","indeterminate":""}},[_c('h4',{staticClass:"subtitle-1 white--text"},[_vm._v("\n      "+_vm._s(_vm.loading.msg)+"\n    ")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }